var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSales = function SvgSales(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.15 6.719a1.43 1.43 0 0 1 .377-.052H27.96c.76 0 1.373.597 1.373 1.333 0 .097-.011.195-.033.29l-2.136 9.333a1.365 1.365 0 0 1-1.34 1.044h-15.8l.643 2.673v-.007h16v1.334h-16v-.806L9.25 22.4 5.004 4h-3.67V2.667h5.333V4h-.172l.653 2.719h.001ZM7.596 8l2.294 9.333h15.933L27.96 8H7.597Z",
    fill: "#5981E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M9.333 21.333h1.334v1.334H9.333v-1.334Z",
    fill: "#5981E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.333 28a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM11.333 28a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM13.333 12h9.334v1.333h-9.334V12Z",
    fill: "#5981E3"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSales);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "2840957114215d30510ded4bc57414a5.svg";